module.exports = __webpack_public_path__ + "static/media/america-santos.79474ee9.jpg";